import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
class Footer extends Component {
  render() {
    return (
      <>
        <footer className="container foot">
          <div className="text-center my-5">
            <div className="my-5">
              <h1>GIMS</h1>
            </div>
          </div>
          <div className="row my-5 text-center">
            <div className="col ">
              <div className="my-5">
                <a className="text-light text-decoration-none" href="/">
                  Home
                </a>
              </div>
              <div className="my-5">
                <a className="text-light text-decoration-none" href="/Delivery">
                  Delivery
                </a>
              </div>
              <div className="my-5">
                <a className="text-light text-decoration-none" href="/Careers">
                  Careers
                </a>
              </div>
              <div className="my-5">
                <a className="text-light text-decoration-none" href="/Press">
                  Press
                </a>
              </div>
              <div className="my-5">
                <a className="text-light text-decoration-none" href="/Customer">
                  Customer Support
                </a>
              </div>
            </div>
            <div className="col ">
              <div className="my-5">
                <a
                  className="text-light text-decoration-none"
                  href="https://m.facebook.com/plxrgaming"
                >
                  Facebook
                </a>
              </div>
              <div className="my-5">
                <a
                  className="text-light text-decoration-none"
                  href="https://www.instagram.com/gamer_plxr"
                >
                  Instagram
                </a>
              </div>
              <div className="my-5">
                <a
                  className="text-light text-decoration-none"
                  href="https://twitter.com/plxrgaming"
                >
                  Twitter
                </a>
              </div>
              <div className="my-5">
                <a
                  className="text-light text-decoration-none"
                  href="https://www.linkedin.com/purav-pawanraj-4a15b224b"
                >
                  Linked In
                </a>
              </div>
            </div>
          </div>
          <div className="text-center">
            <h2>pLxR Technologies Private Limited</h2>
          </div>
          <div className="text-center my-5">
            <h3>
              {" "}
              <a href="/Privacy" className="text-light text-decoration-none">
                Privacy Policy
              </a>
              <a href="/Terms" className="text-light text-decoration-none ms-5">
                Terms of Use
              </a>
              <a
                href="/Disclosure"
                className="text-light text-decoration-none ms-5"
              >
                Responsible Disclosure Policy
              </a>
            </h3>
          </div>
        </footer>
      </>
    );
  }
}
export default Footer;
